import { useQuery } from '@tanstack/react-query';
import { getApi } from '../api';
import { transformSnake2Camel } from './utils';

export const useGetDashboardSection = ({ clientId, context, sectionKey, config = {} } = {}) => {
  const enabled = Boolean(clientId && context && sectionKey);

  return useQuery({
    queryKey: ['GET_DashboardSection', clientId, context, sectionKey],
    enabled,
    queryFn: async () => {
      const { data } = await getApi().get(`v1/clients/${clientId}/dashboard/contexts/${context}/sections/${sectionKey}`);
      return transformSnake2Camel(data);
    },
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    ...config
  });
};
